import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

const useField = (name?: string) => {
  const context = useFormContext();
  const [isForm] = React.useState(!!context);
  const [persistedName] = React.useState(name || '');

  if (isForm && !!persistedName) {
    const {
      field: { onChange, onBlur, value, ref },
      formState: { errors, touchedFields },
      // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useController({
      name: persistedName,
      control: context.control,
    });

    return {
      onBlur,
      onChange,
      value,
      error: touchedFields[persistedName]
        ? (errors?.[persistedName]?.message as unknown as string)
        : null,
      ref,
    };
  }
  return {};
};

export default useField;
